module.exports = __webpack_public_path__ + "img/afbeelding-evenement-4x.bbc19e46.jpg";